import { injectService } from '@/inversify.config';
import { PageSelectorServiceSymbol } from '@/presentation/components/page-selector/PageSelectorService';
import { Icon } from 'patsnap-biz';
import '@patsnap-ui/icon/assets/solid/CheckboxOn.svg';
import '@patsnap-ui/icon/assets/solid/CheckboxOff.svg';
export const name = 'CHECKBOX.render';
// 默认显示模板
function renderDefault(h, renderOpts, params) {
    const { row, rowIndex } = params;
    const { _seqBase } = renderOpts;
    const _seq = _seqBase + rowIndex;
    const { PATENT_ID, read_status } = row || {};
    const pageSelectorService = injectService(PageSelectorServiceSymbol);
    const isChecked = pageSelectorService.isChecked(PATENT_ID, _seq);
    const toggleChecked = () => {
        pageSelectorService.selectOne(PATENT_ID);
    };
    return [
        <div class="xtable-cell-render" cell-type="CHECKBOX" cell-render={name}>
            <div class={{ checked: isChecked }} onClick={toggleChecked}>
                <Icon icon={isChecked ? 'SolidCheckboxOn' : 'SolidCheckboxOff'} style={{ fill: isChecked ? '#1875d1' : '#b3bac5' }}/>
                <span class="seq-index">{_seq}</span>
            </div>
            {!read_status ? <span class="read-status"/> : null}
        </div>,
    ];
}
function renderHeader() {
    // TODO: 左上角的全选 做不做待定（老table没有
    return [];
}
export default {
    renderDefault,
    renderHeader,
};
